import { useEffect, useState } from 'react';

export const useMobileOptimization = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Detect mobile devices
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(mobile);
    };

    // Detect iOS
    const checkIOS = () => {
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      setIsIOS(ios);
    };

    // Detect Android
    const checkAndroid = () => {
      const android = /Android/i.test(navigator.userAgent);
      setIsAndroid(android);
    };

    // Check if running in standalone mode (PWA)
    const checkStandalone = () => {
      const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                        window.navigator.standalone === true;
      setIsStandalone(standalone);
    };

    checkMobile();
    checkIOS();
    checkAndroid();
    checkStandalone();
  }, []);

  // Simple haptic feedback function
  const vibrate = (pattern = 50) => {
    if (navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  };

  // Simple functions that don't interfere with normal behavior
  const preventZoom = () => {
    // Only prevent double-tap zoom, not regular interactions
    let lastTouchEnd = 0;
    document.addEventListener('touchend', (event) => {
      const now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, { passive: false });
  };

  const getSafeAreaInsets = () => {
    if (!isIOS) return { top: 0, bottom: 0, left: 0, right: 0 };

    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    };
  };

  // Empty functions that don't interfere
  const optimizeScroll = () => {
    // Don't interfere with normal scrolling
    return;
  };

  const handleMobileKeyboard = () => {
    // Don't interfere with keyboard handling
    return;
  };

  return {
    isMobile,
    isIOS,
    isAndroid,
    isStandalone,
    vibrate,
    preventZoom,
    getSafeAreaInsets,
    optimizeScroll,
    handleMobileKeyboard,
  };
};